import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ToastHOC from "../HOC/ToastHOC";
import ApiCalling from "../../network/ApiCalling";
import Invalid from "../../assets/Icon/invalid.svg";
import Util from "../../Util";
import Delete from "../../assets/Icon/delete.svg";
import DragIndicator from "../../assets/Icon/drag_indicator 1.svg";
import Spinner from "react-bootstrap/Spinner";

const Settings = (props) => {
  const { t } = useTranslation();
  const { setIsToast, setIsSubToast } = props;
  const data = props?.data;
  const isAdmin = props?.isAdmin;
  console.log("data", props);
  const [properties, setProperties] = useState(true);
  const [status, setStatus] = useState(false);
  const [report, setReport] = useState(false);
  const [frameworkName, setFramework] = useState("");
  const [frameworkErr, setFrameworkErr] = useState("");
  const [frameworkStatus, setFrameworkStatus] = useState(false);
  const [frameworkStatusErr, setFrameworkStatusErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [reportData, setReportData] = useState([
    { page_no: 1, introduction: "" },
  ]);
  const [gradeData, setGradeData] = useState([]);
  const [gradeId, setGradeId] = useState(0);
  const user = Util.getUser();
  const [templateList, setTemplateList] = useState([]);
  const [templateId, setTemplateId] = useState(0);

  // console.log(userSchoolRoles, isUberAdmin);

  const statusList = [
    { id: 1, value: "Active" },
    { id: 2, value: "Inactive" },
  ];

  useEffect(() => {
    if (data) {
      if (data?.name) {
        setFramework(data?.name);
      }
      if (data?.status) {
        setFrameworkStatus(data?.status);
      }
      if (data?.grade_id) {
        setGradeId(data?.grade_id);
      }
      if (data?.template_id) {
        setTemplateId(data?.template_id);
      }
    }
  }, [data]);

  useEffect(() => {
    getFrameworkStatus();
    getReportIntro();
    getGradeList();
    getActiveTemplate();
  }, []);

  const getFrameworkStatus = () => {
    ApiCalling.apiCallParamsGet(`assessments/get-framework-status/${data?.id}`)
      .then((res) => {
        if (res.data) {
          const data = res.data;
          setFormData(data.sort((a, b) => a.position_id - b.position_id));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getReportIntro = () => {
    ApiCalling.apiCallParamsGet(`assessments/get-report-intro/${data?.id}`)
      .then((res) => {
        if (res.data.length > 0) {
          const data = res.data;
          setReportData(data.sort((a, b) => a.page_no - b.page_no));
        } else {
          setReportData([{ page_no: 1, introduction: "" }]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmit = () => {
    setIsLoading(true);
    setFrameworkErr("");
    setFrameworkStatusErr("");
    let error = false;
    if (frameworkName === "") {
      setFrameworkErr("Please enter Framework name");
      error = true;
      setIsLoading(false);
    }
    if (frameworkStatus === 0) {
      setFrameworkStatusErr("Please enter Status");
      error = true;
      setIsLoading(false);
    }
    if (!error) {
      let finaldata;
      if (isAdmin) {
        finaldata = {
          name: frameworkName,
          status: frameworkStatus,
          id: data?.id,
          grade_id: gradeId,
        };
      } else {
        finaldata = {
          name: frameworkName,
          status: frameworkStatus,
          id: data?.id,
        };
      }
      ApiCalling.apiCallBodyDataPost("assessments/update-template", finaldata)
        .then((res) => {
          if (res.data.status) {
            setIsToast("Template Updated successfully");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handleChange = (e, index, id) => {
    const { value } = e.target;
    const newFormData = [...formData];
    newFormData[index] = {
      id: id,
      status: value,
      position_id: index,
      framework_id: data?.id,
    };
    setFormData(newFormData);
  };

  const handleAddStatus = () => {
    setFormData([
      ...formData,
      {
        status: "",
      },
    ]);
  };

  const handleStatusSubmit = (index) => {
    setIsLoading(true);
    const newFormData = [...formData];
    const finalData = newFormData.filter((item) => item.status !== "");
    console.log(finalData);
    const submitData = finalData;
    console.log(submitData);
    submitData.framework_id = data?.id;
    const isEdit = submitData.some(
      (item) => item.id !== undefined || item.id !== null
    );
    console.log(isEdit)
    ApiCalling.apiCallBodyDataPost("assessments/add-status", submitData)
      .then((res) => {
        if (res.data.status) {
          setIsToast(
            isEdit
              ? "Framework Status Created!"
              : "Framwork Status Updated!"
          );
          setIsSubToast(
            isEdit
              ? "Framework Status created successfully"
              : "Framework Status updated successfully"
          );
          getFrameworkStatus();
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleRemoveStatus = (index, id) => {
    const newFormData = [...formData];
    newFormData.splice(index, 1);
    setFormData(newFormData);
    if (id) {
      removeStatus(id);
    }else {
      setIsToast("Subject & Area status Deleted");
    }
  };

  const removeStatus = (id) => {
    ApiCalling.apiCallDelete(`assessments/status/${id}`)
      .then((res) => {
        console.log(res.data);
        setIsToast("Subject & Area status Deleted");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDragStart = (e, index, position_id) => {
    e.dataTransfer.setData("draggedItemIndex", position_id);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = async (e, index, position_id, id) => {
    const draggedItemIndex = e.dataTransfer.getData("draggedItemIndex");

    const updatedFormData = [...formData];

    const draggedItem = updatedFormData[draggedItemIndex];

    if (draggedItem && draggedItemIndex !== index) {
      updatedFormData.splice(draggedItemIndex, 1);

      updatedFormData.splice(index, 0, draggedItem);

      updatedFormData.forEach((item, idx) => {
        item.position_id = idx;
      });
      console.log(updatedFormData);
      setFormData(updatedFormData);
    }
  };

  const handleRemoveReport = (index, id) => {
    const newReportData = [...reportData];
    newReportData.splice(index, 1);
    setReportData(newReportData);
    if (id) {
      removeReport(id);
    } else {
      setIsToast("Report Introduction Deleted");
    }
  };

  const removeReport = (id) => {
    ApiCalling.apiCallDelete(`assessments/report/${id}`)
      .then((res) => {
        console.log(res.data);
        getReportIntro();
        setIsToast("Report Introduction Deleted");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleReportSubmit = () => {
    setIsLoading(true);
    const reportData1 = [...reportData];
    console.log(reportData1);
    ApiCalling.apiCallBodyDataPost("assessments/add-report", reportData1)
      .then((res) => {
        if (res.data.status) {
          setIsToast(
            reportData1?.id === undefined
              ? "Report Introduction Created!"
              : "Report Introduction Updated!"
          );
          setIsSubToast(
            reportData1?.id === undefined
              ? "Report Introduction created successfully"
              : "Report Introduction updated successfully"
          );
        }
        getReportIntro();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleReportChange = (e, index, id) => {
    const { value } = e.target;
    const newFormData = [...reportData];
    newFormData[index] = {
      id: id,
      introduction: value,
      framework_id: data?.id,
      page_no: index + 1,
    };
    setReportData(newFormData);
  };

  const getGradeList = async () => {
    ApiCalling.apiCallBodyDataGet("grade/list")
      .then((res) => {
        setGradeData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getActiveTemplate = async () => {
    ApiCalling.apiCallBodyDataGet("assessments/getActiveTemplate")
      .then((res) => {
        if (res.data) {
          setTemplateList(res.data);
        } else {
          setTemplateList(null);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="container-fluid">
      <div className="school-details my-4">
        <div className="p-3">
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="medium-large-text font-color-primary py-2">
                {t("Properties")}
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <div className="vertical-bar"></div>
                <div
                  className="accoridan-btn"
                  onClick={() => setProperties(!properties)}
                >
                  <i
                    className={
                      !properties ? "fa fa-angle-up" : "fa fa-angle-down"
                    }
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
            </div>
            {properties && (
              <div>
                <div className="row text-start">
                  <div className="col-lg-6 mt-2">
                    <label className="required">Framework Name</label>
                    <input
                      className={`form-control ${
                        frameworkErr.length > 0 ? "input-error" : "custom-input"
                      }`}
                      value={frameworkName}
                      onChange={(e) => {
                        setFramework(e.target.value);
                        setFrameworkErr("");
                      }}
                    />
                    {frameworkErr.length > 0 && (
                      <div className="invalid-error px-0">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {frameworkErr}
                      </div>
                    )}

                    <label className="required mt-4">{t("Status")}</label>
                    <select
                      className={`select-dropdown form-select custom-input ${
                        frameworkStatusErr.length > 0 ? "input-error" : ""
                      }`}
                      name="status"
                      value={frameworkStatus}
                      onChange={(event) => {
                        setFrameworkStatus(event.target.value);
                        setFrameworkStatusErr("");
                      }}
                    >
                      <option value={0} disabled>
                        {t("Status")}
                      </option>
                      {statusList.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.value}
                          </option>
                        );
                      })}
                    </select>
                    {frameworkStatusErr.length > 0 && (
                      <div className="invalid-error px-0">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {frameworkStatusErr}
                      </div>
                    )}
                  </div>

                  {isAdmin && (
                    <div className="col-md-6">
                      <label>Grade</label>
                      <div className="form-group">
                        <select
                          className="select-dropdown form-select  custom-input"
                          value={gradeId}
                          onChange={(e) => {
                            setGradeId(e.target.value);
                          }}
                        >
                          <option value={0} disabled>
                            {t("Select Grade")}
                          </option>
                          {gradeData?.map((item) => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item?.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <label className="mt-3">Template</label>
                      <div className="form-group">
                        <select
                          className="select-dropdown form-select  custom-input"
                          value={templateId}
                          onChange={(e) => {
                            setTemplateId(e.target.value);
                          }}
                          disabled
                        >
                          <option value={""}>{t("Select Template")}</option>
                          {templateList?.map((item) => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item?.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  )}
                </div>
                <div className="d-flex justify-content-end gap-3 align-items-center mt-3">
                  <button
                    className="secondary-md-btn btn ml-2"
                    onClick={() => {
                      setProperties(!properties);
                      setStatus(false);
                      setReport(false);
                    }}
                  >
                    {t("Cancel")}
                  </button>
                  <button
                    className="primary-md-btn btn"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {t("Update")}
                  </button>
                </div>
              </div>
            )}
            <hr style={{ backgroundColor: "#E5E7EB" }} />
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div className="medium-large-text font-color-primary py-2">
                {t("Subject & Area Status")}
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <div className="vertical-bar"></div>
                <div
                  className="accoridan-btn"
                  onClick={() => {
                    setProperties(false);
                    setReport(false);
                    setStatus(!status);
                  }}
                >
                  <i
                    className={!status ? "fa fa-angle-up" : "fa fa-angle-down"}
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
            </div>
            {/* <hr /> */}
            {status && (
              <>
                {formData.map((item, index) => (
                  <>
                    <div
                      key={index}
                      className="mb-3 d-flex justify-content-center align-contents-center"
                      draggable={item.value !== ""}
                      onDragStart={(e) => {
                        if (item?.value !== "") {
                          handleDragStart(e, index, item?.position_id);
                        }
                      }}
                      onDrop={(e) => {
                        if (item.value !== "") {
                          handleDrop(e, index, item?.position_id, item?.id);
                        }
                      }}
                      onDragOver={handleDragOver}
                      style={{
                        background: "white",
                        padding: "10px",
                        cursor: "move",
                      }}
                    >
                      <img src={DragIndicator} draggable="false" />
                      <input
                        type="text"
                        name="area"
                        className={`form-control custom-input`}
                        value={item?.status}
                        onChange={(e) => handleChange(e, index, item?.id)}
                        placeholder="Status"
                      />
                      {index > 0 && (
                        <a
                          type="button"
                          onClick={() => handleRemoveStatus(index, item?.id)}
                          className="d-flex ms-2"
                        >
                          <img src={Delete} alt="Delete" width={20} />
                        </a>
                      )}
                       {index == 0 && (
                        <a
                          type="button"
                          className="d-flex ms-2"
                        >
                          <img src={Delete} alt="Delete" width={20} />
                        </a>
                      )}
                    </div>
                    {formData.length - 1 === index && (
                      <>
                        <div className="p-2">
                          <button
                            className="btn ternary-text"
                            type="button"
                            onClick={() => handleAddStatus()}
                          >
                            + Add New Status
                          </button>
                        </div>
                        <div className="d-flex gap-2 align-items-center justify-content-end p-3">
                          <button
                            type="button"
                            className="secondary-md-btn btn ml-2"
                            onClick={() => {
                              const updatedFormData = [...formData];
                              setFormData(
                                updatedFormData.filter(
                                  (item) => item.status !== ""
                                )
                              );
                              setStatus(!status);
                            }}
                          >
                            Close
                          </button>
                          <button
                            type="button"
                            className="primary-md-btn btn ml-2"
                            onClick={() => {
                              handleStatusSubmit(index);
                            }}
                            disabled={isLoading}
                          >
                            {isLoading ? (
                              <Spinner animation="border" />
                            ) : (
                              "Save"
                            )}
                          </button>
                        </div>
                      </>
                    )}
                  </>
                ))}
              </>
            )}
            <hr style={{ backgroundColor: "#E5E7EB" }} />
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div className="medium-large-text font-color-primary py-2">
                {t("Report Introduction")}
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <div className="vertical-bar"></div>
                <div
                  className="accoridan-btn"
                  onClick={() => {
                    setProperties(false);
                    setReport(!report);
                    setStatus(false);
                  }}
                >
                  <i
                    className={!report ? "fa fa-angle-up" : "fa fa-angle-down"}
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
            </div>
            {/* <hr /> */}
            {report && (
              <>
                {reportData.map((item, index) => (
                  <>
                    <div key={index}>
                      <div className="d-flex justify-content-between">
                        <span>Page {index + 1}</span>
                        {index >= 1 && (
                          <a
                            type="button"
                            onClick={() => handleRemoveReport(index, item?.id)}
                            className="d-flex"
                          >
                            <img src={Delete} alt="Delete" width={20} />
                          </a>
                        )}
                      </div>

                      <textarea
                        className="text-area mb-2"
                        placeholder="Intro..."
                        rows="4"
                        onChange={(e) => handleReportChange(e, index, item?.id)}
                        value={item?.introduction}
                      ></textarea>
                      {reportData.length - 1 === index &&
                        reportData.length <= 1 && (
                          <div className="p-2">
                            <button
                              className="btn ternary-text"
                              type="button"
                              onClick={() =>
                                setReportData([
                                  ...reportData,
                                  { page_no: index + 1, introduction: "" },
                                ])
                              }
                            >
                              + Add New
                            </button>
                          </div>
                        )}
                      {reportData.length - 1 === index && (
                        <>
                          <div className="d-flex gap-2 align-items-center justify-content-end p-3">
                            <button
                              type="button"
                              className="secondary-md-btn btn ml-2"
                              onClick={() => {
                                const updatedFormData = [...reportData];
                                setReportData(
                                  updatedFormData.filter(
                                    (item) => item.introduction !== ""
                                  )
                                );
                                setReport(!report);
                              }}
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="primary-md-btn btn ml-2"
                              onClick={() => {
                                handleReportSubmit(index);
                              }}
                              disabled={isLoading}
                            >
                              {isLoading ? (
                                <Spinner animation="border" />
                              ) : (
                                "Save"
                              )}
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                ))}
              </>
            )}
            <hr style={{ backgroundColor: "#E5E7EB" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToastHOC(Settings);
